import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { fetchUsers } from '../lib/queries.ts';

type AuthorValue = 'me' | 'all' | string;

interface Props {
  value: AuthorValue;
  onChange: (next: AuthorValue) => void;
}

/**
 * Dropdown that selects the createdBy filter for clips/films lists.
 * Default value (caller): 'me'.
 * Loads the list of users for the per-user options. The list is small so
 * a single GET /users on mount is fine.
 */
export function AuthorFilter({ value, onChange }: Props): React.ReactElement {
  const { t } = useTranslation();
  const usersQuery = useQuery({
    queryKey: ['users'],
    queryFn: () => fetchUsers(),
    staleTime: 5 * 60 * 1000,
  });
  const users = usersQuery.data?.users ?? [];

  return (
    <label style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 11, color: 'var(--text-3)' }}>
      {t('common.author')}:
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as AuthorValue)}
        style={{ fontSize: 12, padding: '2px 8px' }}
      >
        <option value="me">{t('common.authorMe')}</option>
        <option value="all">{t('common.authorAll')}</option>
        {users.map((u) => (
          <option key={u.id} value={u.id}>
            {u.email}
          </option>
        ))}
      </select>
    </label>
  );
}
